import type { ShopStatus, ShopSummary, ShopType } from '../../api/types.ts';

export interface ShopFilterState {
  type: ShopType | '';
  status: ShopStatus | '';
  ownerId: string;
}

export interface OwnerOption {
  id: number;
  label: string;
}

export function ownerOptionsFromShops(shops: ShopSummary[]): OwnerOption[] {
  const byId = new Map<number, OwnerOption>();
  for (const shop of shops) {
    for (const owner of shop.owners) {
      if (!byId.has(owner.id)) {
        byId.set(owner.id, { id: owner.id, label: `${owner.first_name} ${owner.last_name}`.trim() });
      }
    }
  }
  return [...byId.values()].sort((a, b) => a.label.localeCompare(b.label));
}

export function filterShops(shops: ShopSummary[], f: ShopFilterState): ShopSummary[] {
  return shops.filter(
    (shop) =>
      (f.type === '' || shop.shop_type === f.type) &&
      (f.status === '' || shop.status === f.status) &&
      (f.ownerId === '' || shop.owners.some((o) => String(o.id) === f.ownerId)),
  );
}
